// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rep-banner-wrapper {
    width: 100%;
    height: 630px;
    flex-shrink: 0;
    z-index: 0;
    content-visibility: auto;
    contain-intrinsic-size: 630px;
}

.rep-banner-wrapper.democrat {
    background: linear-gradient(225deg, #A2021B -18.05%, #0A4CA6 67.39%);
}

.rep-banner-wrapper.republican {
    background: linear-gradient(225deg, #0A4CA6 -18.05%, #A2021B 67.39%);
}

.rep-banner-wrapper.other {
    background: linear-gradient(225deg, #0A4CA6 -18.05%, #A2021B 0%, #808080 20%);
}

.rep-banner-main {
    max-width: 1512px;
    height: 630px;
    position: relative;
    margin: 0 auto;
}

.flag-container {
    position: absolute;
}

.flag-image {
    width: 1011px;
    height: 578px;
    position: absolute;
    left: -60px;
    top: 50px;
    will-change: transform;
}

.flag-image::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 20px;
    height: 100%;
    background: linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
    filter: blur(10px);
    pointer-events: none;
}

.RepresentativeBanner {
    margin: 0 auto;
    width: 426.294px;
    height: 502px;
    border-radius: 25px;
    background: #D9D9D9;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    overflow: hidden;
    left: 144px;
    top: 64px;
    position: absolute;
}

.RepresentativeBanner .main-image {
    max-width: 100%;
    height: auto;
    display: block;
    object-fit: cover;
    object-position: top;
    will-change: transform;
}

.text-container {
    position: absolute;
    left: 672px;
    top: 120px;
    color: #FFF;
}

.text-container .name {
    font-family: Georgia, serif;
    font-size: 64px;
    font-weight: 700;
    line-height: 1.1;
    margin-bottom: 10px;
}

.text-container .party,
.text-container .info {
    font-size: 30px;
    font-weight: 400;
    line-height: 1.3;
    margin-bottom: 5px;
}

.social-media-icons {
    display: flex;
    gap: 15px;
    margin-top: 15px;
}

.social-icon-link {
    display: flex;
    justify-content: center;
    align-items: center;
}

.social-icon {
    width: 30px;
    height: 30px;
    transition: transform 0.2s ease-in-out;
}

.social-icon:hover {
    transform: scale(1.1);
}

@media (max-width: 1224px) {
    .rep-banner-wrapper {
        height: 308px;
        contain-intrinsic-size: 308px;
    }

    .rep-banner-main {
        width: 100%;
    }

    .RepresentativeBanner {
        width: 165px;
        height: 229px;
        border-radius: 11.056px;
        left: 30px;
        top: 42px;
    }

    .RepresentativeBanner .main-image {
        height: 238.938px;
        border-radius: 3.538px;
    }

    .flag-image {
        width: 450px;
        height: 250px;
        left: -60px;
        top: 50px;
    }

    .text-container {
        left: 229px;
        top: 79px;
        width: calc(100% - 229px);
    }

    .text-container .name {
        font-size: 28.091px;
        line-height: 1.4;
        overflow-wrap: break-word;
        word-break: break-word;
        white-space: normal;
        width: 100%;
    }

    .text-container .party,
    .text-container .info {
        font-size: 16.052px;
        line-height: 1.2;
        letter-spacing: 0.442px;
    }

    .social-media-icons {
        margin-top: 10px;
        gap: 10px;
    }

    .social-icon {
        width: 24px;
        height: 24px;
    }
}

@media (prefers-reduced-motion: reduce) {
    .social-icon {
        transition: none;
    }
}

/* Add print styles for better accessibility when printed */
@media print {
    .rep-banner-wrapper {
        background: none !important;
        color: #000;
    }

    .flag-container,
    .social-media-icons {
        display: none;
    }

    .text-container {
        position: static;
        color: #000;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/RepresentativeBanner/style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,UAAU;IACV,wBAAwB;IACxB,6BAA6B;AACjC;;AAEA;IACI,oEAAoE;AACxE;;AAEA;IACI,oEAAoE;AACxE;;AAEA;IACI,6EAA6E;AACjF;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,qFAAqF;IACrF,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sCAAsC;AAC1C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,aAAa;QACb,6BAA6B;IACjC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,uBAAuB;QACvB,UAAU;QACV,SAAS;IACb;;IAEA;QACI,iBAAiB;QACjB,sBAAsB;IAC1B;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,WAAW;QACX,SAAS;IACb;;IAEA;QACI,WAAW;QACX,SAAS;QACT,yBAAyB;IAC7B;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,yBAAyB;QACzB,sBAAsB;QACtB,mBAAmB;QACnB,WAAW;IACf;;IAEA;;QAEI,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA,2DAA2D;AAC3D;IACI;QACI,2BAA2B;QAC3B,WAAW;IACf;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,WAAW;IACf;AACJ","sourcesContent":[".rep-banner-wrapper {\n    width: 100%;\n    height: 630px;\n    flex-shrink: 0;\n    z-index: 0;\n    content-visibility: auto;\n    contain-intrinsic-size: 630px;\n}\n\n.rep-banner-wrapper.democrat {\n    background: linear-gradient(225deg, #A2021B -18.05%, #0A4CA6 67.39%);\n}\n\n.rep-banner-wrapper.republican {\n    background: linear-gradient(225deg, #0A4CA6 -18.05%, #A2021B 67.39%);\n}\n\n.rep-banner-wrapper.other {\n    background: linear-gradient(225deg, #0A4CA6 -18.05%, #A2021B 0%, #808080 20%);\n}\n\n.rep-banner-main {\n    max-width: 1512px;\n    height: 630px;\n    position: relative;\n    margin: 0 auto;\n}\n\n.flag-container {\n    position: absolute;\n}\n\n.flag-image {\n    width: 1011px;\n    height: 578px;\n    position: absolute;\n    left: -60px;\n    top: 50px;\n    will-change: transform;\n}\n\n.flag-image::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 20px;\n    height: 100%;\n    background: linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));\n    filter: blur(10px);\n    pointer-events: none;\n}\n\n.RepresentativeBanner {\n    margin: 0 auto;\n    width: 426.294px;\n    height: 502px;\n    border-radius: 25px;\n    background: #D9D9D9;\n    z-index: 1;\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    overflow: hidden;\n    left: 144px;\n    top: 64px;\n    position: absolute;\n}\n\n.RepresentativeBanner .main-image {\n    max-width: 100%;\n    height: auto;\n    display: block;\n    object-fit: cover;\n    object-position: top;\n    will-change: transform;\n}\n\n.text-container {\n    position: absolute;\n    left: 672px;\n    top: 120px;\n    color: #FFF;\n}\n\n.text-container .name {\n    font-family: Georgia, serif;\n    font-size: 64px;\n    font-weight: 700;\n    line-height: 1.1;\n    margin-bottom: 10px;\n}\n\n.text-container .party,\n.text-container .info {\n    font-size: 30px;\n    font-weight: 400;\n    line-height: 1.3;\n    margin-bottom: 5px;\n}\n\n.social-media-icons {\n    display: flex;\n    gap: 15px;\n    margin-top: 15px;\n}\n\n.social-icon-link {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.social-icon {\n    width: 30px;\n    height: 30px;\n    transition: transform 0.2s ease-in-out;\n}\n\n.social-icon:hover {\n    transform: scale(1.1);\n}\n\n@media (max-width: 1224px) {\n    .rep-banner-wrapper {\n        height: 308px;\n        contain-intrinsic-size: 308px;\n    }\n\n    .rep-banner-main {\n        width: 100%;\n    }\n\n    .RepresentativeBanner {\n        width: 165px;\n        height: 229px;\n        border-radius: 11.056px;\n        left: 30px;\n        top: 42px;\n    }\n\n    .RepresentativeBanner .main-image {\n        height: 238.938px;\n        border-radius: 3.538px;\n    }\n\n    .flag-image {\n        width: 450px;\n        height: 250px;\n        left: -60px;\n        top: 50px;\n    }\n\n    .text-container {\n        left: 229px;\n        top: 79px;\n        width: calc(100% - 229px);\n    }\n\n    .text-container .name {\n        font-size: 28.091px;\n        line-height: 1.4;\n        overflow-wrap: break-word;\n        word-break: break-word;\n        white-space: normal;\n        width: 100%;\n    }\n\n    .text-container .party,\n    .text-container .info {\n        font-size: 16.052px;\n        line-height: 1.2;\n        letter-spacing: 0.442px;\n    }\n\n    .social-media-icons {\n        margin-top: 10px;\n        gap: 10px;\n    }\n\n    .social-icon {\n        width: 24px;\n        height: 24px;\n    }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .social-icon {\n        transition: none;\n    }\n}\n\n/* Add print styles for better accessibility when printed */\n@media print {\n    .rep-banner-wrapper {\n        background: none !important;\n        color: #000;\n    }\n\n    .flag-container,\n    .social-media-icons {\n        display: none;\n    }\n\n    .text-container {\n        position: static;\n        color: #000;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
